/**
 *
 * @author fuyg
 * @date  2020-10-23
 */

const ursCssFiles = {
  messageLogin: '__ursCssMessageLogin__',
  mailLogin: '__ursCssMailLogin__',
  passWordLogin: '__ursCssPassWordLogin__',
  changeMail:'__ursCssChangeMail__',
}

export default ursCssFiles
